// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css';
import iviewArea from 'iview-area'
import App from './App'
import {router} from './router/index'
import store from './store'
import i18n from '@/locale'
import Icon from 'vue-awesome/components/Icon'
// 按需引入awesome图标
import 'vue-awesome/icons/brands/qq'
import 'vue-awesome/icons/brands/weixin'
import 'vue-awesome/icons/brands/weibo'
import 'vue-awesome/icons/brands/github'
import {getRequest, postRequest, putRequest, deleteRequest, uploadFileRequest} from '@/libs/axios'
import {setStore, getStore, removeStore} from '@/libs/storage'
import Cookies from "js-cookie"
import util from '@/libs/util'
import dictUtil from '@/libs/dictUtil'
import hasPermission from '@/libs/hasPermission'
import hasRole from '@/libs/hasRole'
import VueLazyload from 'vue-lazyload'
import VueClipboard from 'vue-clipboard2'
import VueApexCharts from 'vue-apexcharts'
import MetaInfo from 'vue-meta-info'
import '@babel/polyfill'
import {userInfo} from "@/api/index";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {bqjUrl,svipUrl} from '@/config/config';

var totalUserImg = '';


Vue.config.devtools = true;
Vue.config.productionTip = false
Vue.use(VueLazyload, {
    error: require('./assets/img-error.png'),
    loading: require('./assets/loading2.gif')
})
Vue.use(ViewUI, {
    i18n: (key, value) => i18n.t(key, value)
});
Vue.use(iviewArea);
Vue.use(VueClipboard);
Vue.component('icon', Icon);
Vue.use(hasPermission);
Vue.use(hasRole);
Vue.use(MetaInfo)
Vue.use(VueApexCharts)
Vue.use(ElementUI)
Vue.component('apexchart', VueApexCharts)
// 挂载全局使用的方法
Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.uploadFileRequest = uploadFileRequest;
Vue.prototype.setStore = setStore;
Vue.prototype.getStore = getStore;
Vue.prototype.removeStore = removeStore;
// Vue.prototype.API_ROOT_UPLOAD = 'https://fzxhback.bqj.cn/'; //正式环境
//Vue.prototype.API_ROOT_UPLOAD  = 'https://previpback.bqj.cn/'; //预发布环境
Vue.prototype.API_ROOT_UPLOAD = bqjUrl+"/"; //测试环境


//吐司
window.toast = function (str, callbacks) {
    console.log('获取的回调函数的上下文', callbacks)
    var m = document.createElement('div');
    m.innerHTML = str;
    m.style.cssText = "padding:0 30px;font-size:16px; min-width:150px; background:#000; opacity:0.77; height:90px; color:#fff; line-height:90px; text-align:center; border-radius:10px; position:fixed; top:45%; left:45%; z-index:99999999;margin-left:-40px;";
    document.body.appendChild(m);
    setTimeout(function () {
        var d = 0.5;
        m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
        m.style.opacity = '0';
        setTimeout(function () {
            document.body.removeChild(m);
            if (callbacks) {
                callbacks()
            }
        }, d * 1000);
    }, 4000);
}

window.toast2 = function (str, callbacks) {
    console.log('获取的回调函数的上下文', callbacks)
    var m = document.createElement('div');
    m.innerHTML = str;
    m.style.cssText = "padding:0 30px;font-size:16px; min-width:150px; background:#000; opacity:0.77; height:90px; color:#fff; line-height:90px; text-align:center; border-radius:10px; position:fixed; top:45%; left:45%; z-index:99999999;margin-left:-40px;";
    document.body.appendChild(m);
    setTimeout(function () {
        var d = 0.5;
        m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
        m.style.opacity = '0';
        setTimeout(function () {
            document.body.removeChild(m);
            if (callbacks) {
                callbacks()
            }
        }, d * 1000);
    }, 2000);
}

window.toastNewline = function(str) {
    // 移除已存在的toast
    var existingToast = document.querySelector('.custom-toast');
    if (existingToast) {
        document.body.removeChild(existingToast);
    }

    // 创建toast元素
    var m = document.createElement('div');
    m.innerHTML = str.replace(/\n/g, '<br><br>');
    m.className = 'custom-toast';

    // 设置样式 - 支持换行
    m.style.cssText = `
                padding: 20px 30px;
                font-size: 16px;
                min-width: 200px;
                max-width: 80%;
                background: #000;
                opacity: 0;
                color: #fff;
                text-align: center;
                border-radius: 10px;
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 99999999;
                box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                transition: opacity 0.3s ease;
                white-space: normal;
                word-wrap: break-word;
                display: flex;
                align-items: center;
                justify-content: center;
            `;

    document.body.appendChild(m);

    // 淡入效果
    setTimeout(function() {
        m.style.opacity = '0.85';
    }, 10);

    // 4秒后淡出并移除
    setTimeout(function() {
        m.style.opacity = '0';
        setTimeout(function() {
            if (document.body.contains(m)) {
                document.body.removeChild(m);
            }
        }, 300);
    }, 6000);
};
/* eslint-disable no-new */


router.beforeEach((to, from, next) => {
    if (window._hmt) {
        if (to.path) {
            window._hmt.push(['_trackPageview', to.fullPath])
        }
    }


    let accessToken = getStore('accessToken');
    if (!accessToken || accessToken == '') {

        if (Cookies.get('accessToken') && Cookies.get('accessToken') != '') {
            accessToken = Cookies.get('accessToken');
            setStore("accessToken", accessToken);

            // 获取用户信息
            userInfo().then(res => {

                if (res.code == 200) {
                    Cookies.set("userInfo", JSON.stringify(res.result));
                    setStore("userInfo", res.result);
                    let photo = res.result.photo ? res.result.photo : ''
                    store.commit("setAvatarPath", photo);
                    // 加载菜单
                    util.initRouter(this);
                    next()
                } else {
                    next()
                }
            },err=>{
                next()
            });
        } else {
            next()
        }
    } else {

        if(!Cookies.get('userInfo') || Cookies.get('userInfo') == ''){
            // 获取用户信息
            userInfo().then(res => {

                if (res.code == 200) {
                    Cookies.set("userInfo", JSON.stringify(res.result));
                    setStore("userInfo", res.result);
                    totalUserImg = res.result.photo ? res.result.photo : ''
                    store.commit("setAvatarPath", totalUserImg);
                    // 加载菜单
                    util.initRouter(this);
                    next()
                } else {
                    next()
                }
            },err=>{
                next()
            });
        }
        else{
            next()

        }



    }




})


new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App),
    data: {
        currentPageName: ''
    },
    mounted() {
        // 初始化菜单
        util.initRouter(this);
        // 初始化全局数据字典
        dictUtil.initDictData(this);
        this.currentPageName = this.$route.name;
        // 显示打开的页面的列表
        this.$store.commit('setOpenedList');
        this.$store.commit('initCachepage');
        // document.dispatchEvent(new Event('render-event'))

        if (process.env.NODE_ENV !== 'development') {
            console.log = function () {}
            // console.error = function(){}
            console.dir = function(){}
        }
    }
})//.$mount('#app')


// 加入百度统计
// var  _hmt  =  _hmt  ||  [];
// window._hmt = _hmt; // 修改为window 全局变量
// (function()  {
//     var  hm  =  document.createElement("script");
//     hm.src  =  "https://hm.baidu.com/hm.js?27cf4e0bca8d51f082b6925a6e1ac9a9";
//     var  s  =  document.getElementsByTagName("script")[0];
//     s.parentNode.insertBefore(hm,  s);
// })();

// router.beforeEach((to, from, next) => {
//     if (window._hmt) {
//         if (to.path) {
//             window._hmt.push(['_trackPageview', to.fullPath])
//         }
//     }
//     console.log('进行守卫');
//     next()
// })
